import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type { AccreditationStandardList } from '../../_types/awb';

export const fetchAccreditationStandards = async (accreditationBodyId: string, versionId: string) => {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${versionId}/standards`;

  const data = await fetcher({
    method: 'get',
    url,
  });
  return data.sort((a: AccreditationStandardList, b: AccreditationStandardList) => a.position - b.position);
};

export default function useAccreditationStandards(
  accreditationBodyId: string,
  versionId: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<AccreditationStandardList[], Error>(
    ['accreditation_standards', accreditationBodyId, versionId],
    () => fetchAccreditationStandards(accreditationBodyId, versionId),
    {
      enabled: !!versionId,
      staleTime: 900000, // 15 minutes in milliseconds
      ...options,
    }
  );
}
